import WebsiteTarget from '../../../../components/AssetManagement/Overview/WebsiteTarget/WebsiteTarget';

const WebsiteTargetScreen = ({ userToken }: { userToken: any }) => {

  return (
    <>
      <WebsiteTarget userToken={userToken} />
    </>
  )
}

export default WebsiteTargetScreen
